import { ComboField } from '@components/Fields/ComboField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { IValueState } from '@hooks/useValueState';
import { MenuItem } from '@material-ui/core';
import { IComboContratoOperadora } from '@model/ContratoOperadora';
import { IRelatorioStatusLinhaFilter } from '@services/RelatorioService';
import React from 'react';

export type RelatorioStatusLinhaFilterProps = {
    filter: IFilter<IRelatorioStatusLinhaFilter>
    isLoading: boolean
    contratoOperadoraCombo: IComboContratoOperadora
    numerosContrato: IValueState<string[]>
    onSearch: VoidFunction
}

export function RelatorioStatusLinhaFilter ({ filter, isLoading, contratoOperadoraCombo, numerosContrato, onSearch }: RelatorioStatusLinhaFilterProps) {
    return (
        <FixedFilterPanel
            onSearch={onSearch}
            onClear={filter.resetFilter}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <StringField
                        field={filter.fields.ddd}
                        label="DDD"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        inputProps={{
                            maxLength: 2
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <StringField
                        field={filter.fields.telefone}
                        label="Telefone"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.numerosContrato}
                        label="Número Contrato"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="">Todos</MenuItem>
                        <MenuItem key={1} value="-1">Em Branco</MenuItem>
                        {
                            numerosContrato.value?.map(numeroContrato => <MenuItem key={numeroContrato} value={numeroContrato}>{numeroContrato}</MenuItem>)
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={3}>
                    <ComboField
                        field={filter.fields.contratoOperadoraId}
                        label="Empresa/Operadora"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={0}>Nenhuma</MenuItem>
                        {
                            contratoOperadoraCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}